export BankId from './bank-id';
export EmailCapture from './email-capture';
export BankIdError from './error';
export GetBankId from './get-bank-id';



/** WEBPACK FOOTER **
 ** ./src/components/bank-id/index.js
 **/